<template>
    <div class="container">
        <div class="title">
            <div class="title-text">
                <span v-if="$route.query.app_id">服务详情 (appid: {{$route.query.app_id}})</span>
                <span v-else>新建服务</span>
            </div>
        </div>
        <el-form :model="form" :rules="rules" ref="form" label-width="180px">
            <el-form-item label="服务名称" prop="app_name">
                <el-input v-model="form.app_name"
                placeholder="请填写收银台的业务名称,3-10个字符"
                minlength="3" maxlength="10"
                show-word-limit clearable></el-input>
            </el-form-item>
            <el-form-item label="业务接口人电话" prop="interface_phone">
                <el-input v-model="form.interface_phone"
                placeholder="请填写运营负责人电话，用于处理客户投诉时高效沟通" maxlength="11"
                show-word-limit clearable></el-input>
            </el-form-item>
			<el-form-item label="业务接口人邮箱" prop="interface_mail">
                <el-input v-model="form.interface_mail" placeholder="请务必填写百度邮箱"
                maxlength="50" show-word-limit clearable></el-input>
            </el-form-item>

            <h3 class="cont-head">用户支付消息通知设置</h3>
			<el-form-item label="支付商家名称" prop="pay_merchant_name">
                <el-input v-model="form.pay_merchant_name"
                placeholder="请输入2-20个字符，用于在用户支付后发送支付消息通知"
                minlength="2" maxlength="20" show-word-limit clearable></el-input>
            </el-form-item>
			<el-form-item label="支付商家头像" prop="pay_merchant_title_url">
				<el-upload
                    v-model="form.pay_merchant_title_url"
                    action="/platform/interface/uploadimg"
                    list-type="picture-card"
                    name="imgFile"
                    :limit="1"
                    :file-list="imgList"
                    :before-upload="beforeAvatarUpload"
                    :on-preview="handlePreview"
                    :on-success="handleSuccess"
                    :on-remove="handleRemove"
                    :on-exceed="handleExceed"
                    :on-error="handleError">
                    <i class="el-icon-plus"></i>
                </el-upload>
                <div class="img-upload-tip">只能上传 jpg/jpeg/bmp/png 文件，且不超过10mb</div>
                <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
            </el-form-item>
            <el-form-item label="支付商家跳转链接" prop="subTitle">
                <el-input v-model="form.pay_merchant_web" placeholder="请输入跳转链接，用户支付后，在向用户发送支付消息通知时回访商家" maxlength="120" show-word-limit clearable></el-input>
            </el-form-item>
            <!-- todo -->
            <!-- action="http://10.94.33.32:8874/platform/interface/uploadimg" -->
            <h3 class="cont-head">支付设置</h3>
            <el-form-item label="接入类型">
                <span class="required">*</span>
                <el-radio-group v-model="directAppType" :disabled="isedit" @change="chagechannel">
                    <el-radio :label="1">托管型</el-radio>
                    <el-radio :label="2">非托管型</el-radio>
                </el-radio-group>
            </el-form-item>
            <template v-if="directAppType == 1">
                <h3 class="cont-head">支付通道</h3>
                <el-form-item label=" " prop="payChannel">
                    <!-- 编辑页面，初始化时候有两个支付通道，可以取消勾选某一个 -->
                    <el-checkbox-group v-model="payChannel" @change="change_group">
                        <!-- <el-checkbox  v-for="payChannel in payChannelList"
						:value="payChannel.value"
                        :disabled="true"
                        :label="payChannel.value" :key="payChannel.label">{{payChannel.label}}</el-checkbox> -->

                        <el-checkbox  
						value="1"
                        :disabled="disabledWC || $route.query.edit == 1 && firstPayChannel === 1"
                        label="1" key="微信（h5支付）">微信（h5支付）</el-checkbox>
                        <el-checkbox  
						value="2"
                        :disabled="disabledAL || $route.query.edit == 1 && firstPayChannel === 1"
                        label="2" key="支付宝">支付宝</el-checkbox>

                    </el-checkbox-group>
                </el-form-item>
                <template v-if="payChannel.indexOf('1') > -1">
                    <h4 class="cont-head">接入渠道 &nbsp;&nbsp;&nbsp;&nbsp;微信</h4>
                    <el-form-item label="Appid" prop="we_chat_app_id">
                        <el-input v-model="form.we_chat_app_id" placeholder="18个字符"
                        :disabled="disabledWC" maxlength="18"
                        show-word-limit clearable></el-input>
                    </el-form-item>
                    <el-form-item label="商户号" prop="we_chat_mcht">
                        <el-input v-model="form.we_chat_mcht" placeholder="19个数字" :disabled="disabledWC"
                        maxlength="19" show-word-limit clearable></el-input>
                    </el-form-item>
                    <el-form-item label="密钥" class="wechatkey-item" prop="we_chat_key">
                        <!-- <span :class="showpass ? 'showpass' : 'hidepass'" @click="toggelpass"></span> -->
                        <el-input v-model="form.we_chat_key" placeholder="64个字符"
                        :disabled="disabledWC" maxlength="64"
                        show-word-limit clearable></el-input><!--  @blur="actualWCKey = form.we_chat_key" @change="showwechatkey = false"
                        
                        @focus="showpassval" -->
                        
                    </el-form-item>
                    <el-form-item label="证书（文件后缀名.p12）" prop="we_chat_certificate_url">
                        <el-upload
                        v-model="form.we_chat_certificate_url"
                        class="upload-demo"
                        action="/platform/interface/uploadfile"
                        :on-preview="handlePreview"
                        :on-remove="handleRemoveFile"
                        :before-remove="beforeRemove"
                        :disabled="disabledWC"
                        accept=".p12"
                        multiple
                        :limit="1"
                        :on-success="handleFileSuccess"
                        :on-exceed="handleExceed"
                        :file-list="fileList">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传.p12文件</div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="证书密码" prop="we_chat_password">
                        <el-input v-model="form.we_chat_password" placeholder="64个字符" :disabled="disabledWC" maxlength="64" show-word-limit clearable></el-input>
                    </el-form-item>
                </template>
                <template v-if="payChannel.indexOf('2') > -1">
                    <h4 class="cont-head">接入渠道 &nbsp;&nbsp;&nbsp;&nbsp;支付宝</h4>
                    <el-form-item label="Appid" prop="ali_app_id">
                        <el-input v-model="form.ali_app_id" placeholder="18个字符"
                        :disabled="disabledAL" maxlength="18"
                        show-word-limit clearable></el-input>
                    </el-form-item>
                    <el-form-item label="支付宝公钥" prop="ali_public_key">
                        <el-input v-model="form.ali_public_key" placeholder="1024个数字"
                        :disabled="disabledAL" maxlength="1024"
                        :rows="4" type="textarea"
                        show-word-limit clearable></el-input>
                    </el-form-item>
                    <el-form-item label="开发者私钥" prop="ali_developer_key">
                        <el-input v-model="form.ali_developer_key" placeholder="3000个字符"
                        :rows="10" type="textarea"
                        :disabled="disabledAL" maxlength="3000"
                        show-word-limit clearable></el-input>
                    </el-form-item>
                    
                </template>
            </template>
            <template v-if="directAppType == 2">
                <h3 class="cont-head">查单地址</h3>
                <el-form-item label="接口地址" prop="order_query_url">
                    <el-input v-model="form.order_query_url" placeholder="提供规范化查单接口"
					:disabled="disabledURL"
                    maxlength="120" show-word-limit clearable></el-input>
                </el-form-item>
            </template>
        </el-form>
        <div class="btn-line">
            <el-button type="primary" @click="onSubmit('form')">提交</el-button>
            <el-button @click="$router.push('/directConnectService')">返回</el-button>
        </div>
        
    </div>
</template>
<script>
export default {
    watch: {
        'directAppType': {
            handler(nel) {
                this.form.direct_app_type = nel;
            }
		},
        'payChannel': {
            handler(nel) {
                this.form.pay_channel = nel;
            }
        },
		'form.we_chat_key': {
            handler(val) {
                if (val) {
                    let l = this.form.we_chat_key.length;
                    this.wechatkey = '';
                    for (let i = 0; i < l; i++) {
                        this.wechatkey += '*';
                    }
                }
            }
        }
    },
    data() {
        let validatemail = (rule, value, callback) => {
            let mailrule = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@baidu.com$/;
            if (!mailrule.test(value)) {
                callback(new Error('请输入正确格式的邮箱'));
            }
            else {
                callback();
            }
        };
        let valDirectAppType = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请选择接入类型'));
            }
            else {
                callback();
            }
        };
        return {
            firstPayChannel: [], // 编辑初始化时候的支付通道
			disabledURL: false, // 查单地址不可修改
            wechatkey: '', // 微信密钥****
            showpass: true,
			directAppType: null,
			payChannel: [],
            // 提交表单
            form: {
                app_name: '',
                interface_phone: '',
                interface_mail: '',
                pay_merchant_name: '', // 商家名称
                pay_merchant_title_url: '', // 商家头图
                pay_merchant_web: '', // 商家官网
                service_type: 6,
                order_query_url: '', //
                pay_channel: [],
                ali_app_id: '',
                we_chat_app_id: '',
                direct_app_type: 0
            },
            payChannelList: [
                {
                    label: '微信（h5支付）',
                    value: '1'
                },
                {
                    label: '支付宝',
                    value: '2'
                }
            ],
            disabledAL: false,
            disabledWC: false,
            imgList: [
                // {
                //     name: '',
                //     url: 'https://tspd-platform.cdn.bcebos.com/32913415/c12c5f3d160114edd25b6cbde52b2aad.jpeg'//this.form.pay_merchant_title_url
                // }
            ],
            // 上传图片列表
            fileList: [],
            // 预览图片弹框展示
            dialogVisible: false,
            // 预览图片url
            dialogImageUrl: '',
            // 富文本编辑器内容
            content: '',
            // 校验
            rules: {
                'app_name': [
                    {required: true, message: '请输入服务名称', trigger: 'blur'},
                    {min: 3, max: 10, message: '名称不能超过10个字符', trigger: 'blur'}
                ],
                'interface_phone': [
                    {required: true, max: 11, message: '请填写业务接口人电话', trigger: 'blur'},
                    {min: 8, max: 11, message: '电话格式不正确', trigger: 'blur'}
                ],
                'interface_mail': [
                    {required: true, message: '请填写接口人邮箱', trigger: 'blur'},
                    {validator: validatemail, message: '请输入百度邮箱', trigger: 'blur'}
                ],
                'pay_merchant_name': [
                    {required: true, message: '请填写商家名称', trigger: 'blur'}
                ],
                'directAppType': [
                    {required: true, message: '请选择接入类型', trigger: 'change'},
                    {validator: valDirectAppType, message: '请选择接入类型', trigger: 'blur'}
                ],
                'pay_merchant_title_url': [
                    {required: true, message: '请上传商家头像', trigger: 'blur'}
                ],
                'pay_channel': [
                    {required: true, message: '请选择支付通道', trigger: 'change'}
                ],
                'we_chat_mcht': [
                    {required: true, message: '请输入微信商户号', trigger: 'blur'}
                ],
                'we_chat_key': [
                    {required: true, message: '请输入微信密钥', trigger: 'blur'}
                ],
                'we_chat_certificate_url': [
                    {required: true, message: '请上传微信证书', trigger: 'blur'}
                ],
                'we_chat_password': [
                    {required: true, message: '请输入微信证书密码', trigger: 'blur'}
                ],
                'ali_public_key': [
                    {required: true, message: '请输入支付宝公钥', trigger: 'blur'}
                ],
                'ali_developer_key': [
                    {required: true, message: '请输入开发者私钥', trigger: 'blur'}
                ],

                'order_query_url': [
                    {required: true, message: '请输入查单地址（接口链接）', trigger: 'blur'}
                ],
                'we_chat_app_id': [
                    {required: true, message: '请输入微信Appid）', trigger: 'blur'}
                ],
                'ali_app_id': [
                    {required: true, message: '请输入支付宝Appid）', trigger: 'blur'}
                ]
            },
            isedit: false // 是否编辑页面
        };
    },
    mounted() {
        if (+this.$route.query.app_id) {
            // type为查看服务状态
            this.getServiceDetail();
            this.isedit = true;
        }
    },
    methods: {
		change_group(val) {
			console.log(val);
		},
        chagechannel() {
            this.$refs.form.clearValidate('directAppType');
            this.$refs.form.clearValidate('order_query_url');
        },
        // 在按下键盘的时候，如果输入框展示的是星号，先将其变成明文
        showpassval() {
            this.showpass = true;
            // this.form.we_chat_key = this.actualWCKey;
        },
        toggelpass() {
            if (this.showpass) {
                this.form.we_chat_key = this.actualWCKey;
            }
            else {
                this.form.we_chat_key = this.wechatkey;
            }
            this.showpass = !this.showpass;
        },
        getServiceDetail() {
            this.$api.serviceDetail({
                app_id: this.$route.query.app_id,
                pageType: 1
            }).then(res => {
                let data = Object.assign(res.data, res.data.directAppVo)
                this.form = data;
                for (let key in data.directAppVo) {
                    this.form[key] = data.directAppVo[key] || data[key];
				}
				// 设置接入类型的值
                this.directAppType = data.directAppVo.direct_app_type;
                this.payChannel = data.directAppVo.pay_channel.split(',');
                this.firstPayChannel = data.directAppVo.pay_channel.split(',').length;
                this.form.pay_merchant_name = data.pay_merchant_name;
                this.form.pay_merchant_title_url = data.pay_merchant_title_url;
                this.form.pay_merchant_web = data.pay_merchant_web;
                this.form.app_name = data.app_name;
                // this.form.pay_channel = res.data.directAppVo.pay_channel;
                this.form.direct_app_type = data.directAppVo.direct_app_type;
                // 微信渠道不可编辑 0未录入 5驳回时候可以编辑
                if (this.form.we_chat_status === 0 || this.form.we_chat_status === 5) {
                    this.disabledWC = false;
                }
                else {
                    this.disabledWC = true;
                }
                // 支付宝渠道不可编辑
                if (this.form.ali_status === 0 || this.form.ali_status === 5) {
                    this.disabledAL = false;
                }
                else {
                    this.disabledAL = true;
                }
				// 查单地址审核通过时候不可编辑
                if (this.isedit && this.direct_app_status === 4) {
                    this.disabledURL = true;
                }
                this.actualWCKey = this.form.we_chat_key;
                this.imgList = [
                    {
                        name: '',
                        url: this.form.pay_merchant_title_url
                    }
                ];
                if (this.form.we_chat_certificate_url) {
                    this.fileList = [
                        {
                            name: '',
                            url: this.form.we_chat_certificate_url
                        }
                    ];
                } 
            }).catch(e => {
                // 接口失败做的操作
                console.log(e);
            });
        },
        beforeUpload(file) {
            const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp');
            const isLt2M = file.size / 1024 / 1024 < 10;

            if (!isJPG) {
                this.$message.error('上传图片只能是jpg/jpeg/bmp/png格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 10MB!');
            }
            return isJPG && isLt2M;
        },
        // 图片头图上传前的格式+大小校验
        beforeAvatarUpload(file) {
            this.beforeUpload(file);
        },
        // 删除文件
        beforeRemove(file) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        // 删除图片
        handleRemove(file) {
            this.imgList.forEach((val, index) => {
                console.log(val);
                console.log(file);
                if (val.url === file.url) {
                    this.imgList.splice(index, 1);
                    this.form.pay_merchant_title_url = '';
                }
            });
            
        },
        // 删除文件
        handleRemoveFile(file) {
            // console.log(file);
            // console.log(file.response.data);
            this.fileList.forEach((val, index) => {
                console.log(val);
                console.log(file);
                if (val.url === file.url) {
                    this.fileList.splice(index, 1);
                    this.form.we_chat_certificate_url = '';
                }
            });
        },
        // 预览图片
        handlePreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        // 图片上传成功
        handleSuccess(res, file) {
            console.log(res, file, 88989898989898);
            // todo
            // if (+res.errno !== 0) {
            if (+res.code !== 0) {
                this.imgList.splice(this.imgList.length - 1, 1);
                this.$message({
                    type: 'error',
                    message: res.errmsg
                });
                return;
            } else {
                this.imgList.push({
                    name: '',
                    url: res.data.imgUrl
                });
                this.form.pay_merchant_title_url = res.data.imgUrl;
            }
        },
        // 图片上传成功
        handleFileSuccess(res, file) {
            console.log(res, file, 88989898989898);
            // todo
            // if (+res.errno !== 0) {
            if (+res.code !== 0) {
                this.form.we_chat_certificate_url = '';
                this.fileList.splice(this.fileList.length - 1, 1);
                this.$message({
                    type: 'error',
                    message: res.errmsg
                });
                return;
            } else {
                this.fileList.push({
                    name: '',
                    url: res.data.imgUrl
                });
                this.form.we_chat_certificate_url = res.data.imgUrl;
            }
        },
        // 超出上传限制数
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制上传1个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        // 图片上传报错
        handleError(err, file, fileList) {
            console.log(err, file, fileList, 123456789)
        },
        // 提交
        onSubmit(form) {
            // 所有上传的值去掉收尾空格
            for (let p in this.form) {
                if (typeof this.form[p] === 'string') {
                    this.form[p] = this.form[p].trim();
                }
            }
            let me = this;
            this.$refs[form].validate((valid) => {
                console.log(this.directAppType);
                if (valid && this.directAppType) {
                    console.log(this.payChannel);
                    // 校验支付通道
                    if (me.directAppType === 1 && !me.payChannel.length) {
                        this.$message.error('请选择支付渠道');
                        return false;
                    }
                    this.submitApi();
                } else if (!this.directAppType) {
                    this.$message.error('请选择接入类型');
                    return false;
                } else {
                    return false;
                }
            });
        },
        // 校验其他
        validothers() {
            if (+this.form.direct_app_type === 1) {
                if (this.form.pay_channel.length === 0) {
                    return false;
                }
            }
            else {
                return true;
            }
        },
        submitApi() {
            const me = this;
            // this.form.we_chat_key = this.actualWCKey;
            this.$api.serviceRegister(this.form).then(res => {
                if (res.code === 0) {
                    me.$message.success('提交成功');
                    this.$router.push('/directConnectService');
                }
                else {
                    me.$message.error(res.msg);
                }
            }).catch(e => {
                this.$message.error('网络错误，请重新提交');
                // 接口失败做的操作
                console.log(e);
            });
            
        }
    }
};
</script>
<style lang="less" scoped>
.container {
    .title {
        width: 100%;
        border: solid 1px #EBEEF5;
        color: #303133;
        font-size: 20px;
        padding: 20px 15px;
        border-radius: 4px;
        margin: 0 0 20px 0;
        .title-text {
            display: flex;
            align-items: center;
            .title-logo {
                width: 20px;
                margin-right: 12px;
            }
        }
    }
    .cont-head {
        border-top: 1px solid #DCDFE6;
        padding: 10px 0 20px;
    }
    .el-form {
        margin-top: 50px;
        width: 60%;
    }
    .el-form-item__content {
        margin-left: 0;
        text-align: center;
    }
    .button-wrapper {
        margin-top: 100px;
        text-align: center;
    }

    .pic-wrapper {
        width: 150px;
        height: 150px;
        background-size: contain;
    }

    .detail-show-wrapper {
        background-size: contain;
        width: 250px;
        height: 500px;
        padding: 20px;
        .contain {
            width: 200px;
            height: 100%;
            overflow: scroll;
            padding: 10px;
        }
    }

    .no-rich-detail {
        padding-left: 15px;
        color: #606266;
    }

    .img-upload-tip {
        color: #606266;
    }

    .plantform-attr1-wrapper {
        padding: 0 20px 20px 15px;
        .attr-name {
            color: #606266;
        }
        .attr-tag {
            margin: 0 5px 8px 0;
        }
    }

    .plantform-attr2-wrapper {
        padding: 0 20px 20px 15px;
        .attr-name {
            width: 100px;
            color: #606266;
        }
    }

    .no-platform-attr {
        padding-left: 15px;
        color: #606266;
    }

    .merchant-attribute-wrapper {
        position: relative;
        padding: 0 20px 20px 15px;
        color: #606266;
        .close {
            position: absolute;
            top: 0;
            right: 18px;
            font-size: 25px;
            color: #DCDFE6;
        }
    }
    .wechatkey-item {
        display: relative;
    }
    .wechatkey {
        position: absolute;
        z-index: 2222;
        left: 16px;
    }
    .btn-line {
        margin: 0 auto;
        text-align: center;
    }
    
    .showpass {
        background: url('../../img/openeye.png');
        background-size: contain;
        width: 30px;
        height: 30px;
        display: inline-block;
    }
    .hidepass {
        background: url('../../img/closeeye.png');
        background-size: contain;
        width: 30px;
        height: 30px;
        display: inline-block;
    }
    .el-upload-list__item.is-ready,
    .el-upload-list__item.is-uploading {
        display: none !important;
    }
    .required {
        color: red;
        position: absolute;
        left: -78px;
    }
}
</style>